export const BASE_URL = "https://easypointapi.com/api";
export const KEY = "1k8FbYJ1j5q7DkzcQ5Vj";
export const SECRET = "hZvYnUiPZHnc14tJLLAL";
